import { Mic } from "lucide-react";

export const varsDuTheme = (tokens = {}) => Object.fromEntries(Object.entries(tokens).map(([k, v]) => [`--${k}`, v]));

const FicheMini = ({ temp, largeur, grand }) => (
  <div className="at-fiche relative overflow-hidden flex items-center justify-between" style={{ padding: grand ? "12px 14px 12px 18px" : "6px 8px 6px 11px" }}>
    <span className="absolute left-0 top-0 bottom-0" style={{ width: grand ? 5 : 3, background: `var(--temp-${temp})` }} />
    <div className="space-y-1" style={{ width: largeur }}>
      <span className="block at-pill" style={{ height: grand ? 9 : 5, background: "var(--ink)", opacity: 0.85 }} />
      <span className="block at-pill w-2/3" style={{ height: grand ? 7 : 4, background: "var(--muted)", opacity: 0.6 }} />
    </div>
    <span className="at-pill" style={{ width: grand ? 54 : 26, height: grand ? 18 : 9, background: `color-mix(in srgb, var(--temp-${temp}) 18%, transparent)` }} />
  </div>
);

export const ThemeMiniature = ({ tokens, grand = false, testId }) => (
  <div data-testid={testId} className="relative overflow-hidden" aria-hidden="true"
    style={{ ...varsDuTheme(tokens), background: "var(--bg)", color: "var(--ink)", fontFamily: "var(--font)", borderRadius: "var(--radius-card)", padding: grand ? 20 : 10 }}>
    <div className="absolute inset-0 pointer-events-none" style={{ background: "var(--glow-gradient)" }} />
    <div className="relative flex items-center justify-between" style={{ marginBottom: grand ? 14 : 7 }}>
      <div className="flex items-center gap-1.5">
        <span className="flex items-center justify-center" style={{ width: grand ? 26 : 13, height: grand ? 26 : 13, borderRadius: grand ? 8 : 4, background: "var(--accent)" }}>
          <span className="at-pill" style={{ width: grand ? 10 : 5, height: grand ? 10 : 5, background: "var(--micro)" }} />
        </span>
        <span className="font-bold tracking-tight" style={{ fontSize: grand ? 17 : 9 }}>airthermo</span>
      </div>
      <div className="flex gap-1">{[0, 1, 2].map((i) => <span key={i} className="at-pill" style={{ width: grand ? 22 : 10, height: grand ? 22 : 10, background: "var(--surface)" }} />)}</div>
    </div>
    <div className="relative flex gap-1" style={{ marginBottom: grand ? 14 : 7 }}>
      {["Accueil", "Pipeline", "Fiches"].map((o, i) => (
        <span key={o} className="at-pill font-semibold" style={{ fontSize: grand ? 13 : 7, padding: grand ? "6px 12px" : "2px 6px", background: i === 0 ? "var(--accent)" : "var(--surface)", color: i === 0 ? "var(--accent-ink)" : "var(--ink)" }}>{o}</span>
      ))}
    </div>
    <div className="relative at-card" style={{ padding: grand ? 16 : 8 }}>
      <p className="font-bold" style={{ fontSize: grand ? 20 : 10, marginBottom: grand ? 4 : 2 }}>Bonjour Erwan.</p>
      <p style={{ fontSize: grand ? 13 : 7, color: "var(--muted)", marginBottom: grand ? 12 : 6 }}>Mairie de Landerneau · 22 650 €</p>
      <div className="space-y-1.5">
        <FicheMini temp={1} largeur={grand ? 140 : 60} grand={grand} />
        <FicheMini temp={4} largeur={grand ? 110 : 48} grand={grand} />
        {grand && <FicheMini temp={7} largeur={130} grand />}
      </div>
      {grand && (
        <div className="flex gap-2 mt-4">
          <span className="at-btn at-btn-primary" style={{ minHeight: 38 }}>Appeler</span>
          <span className="at-btn at-btn-ghost" style={{ minHeight: 38 }}>Message</span>
        </div>
      )}
    </div>
    <span className="absolute at-micro flex items-center justify-center" style={{ right: grand ? 18 : 8, bottom: grand ? 18 : 8, width: grand ? 46 : 20, height: grand ? 46 : 20 }}>
      <Mic size={grand ? 20 : 10} />
    </span>
  </div>
);
